import { processSteps } from "@/mocks/homeData";

export default function ProcessSection() {

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-6 md:px-12 lg:px-20 xl:px-24 max-w-[1440px] mx-auto">

        {/* Nagłówek */}
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-18">
          <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-primary-500 mb-4 block animate-fade-in-up">
            Proces
          </span>
          <h2 className="font-heading text-[2.2rem] md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 animate-fade-in-up animation-delay-100">
            Jak działam
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed animate-fade-in-up animation-delay-200">
            Prosty, transparentny proces współpracy – od pierwszego spotkania aż do podpisania umowy.
          </p>
        </div>

        {/* ============================================================
            DESKTOP – Horizontal timeline (2 rzędy po 3)
        ============================================================ */}
        <div className="hidden md:block">
          {/* Rzęd 1: kroki 1–3 */}
          <div className="relative mb-16">
            {/* Linia pozioma */}
            <div className="absolute top-[28px] left-[16.66%] right-[16.66%] h-[2px] bg-primary-500/20" />

            <div className="grid grid-cols-3 gap-8">
              {processSteps.slice(0, 3).map((step, index) => (
                <div
                  key={step.step}
                  className="flex flex-col items-center text-center animate-fade-in-up"
                  style={{ animationDelay: `${(index + 1) * 150}ms` }}
                >
                  {/* Kółeczko z numerem */}
                  <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full border-2 border-primary-500 bg-background-50 mb-5">
                    <span className="font-heading text-sm font-bold text-primary-500">
                      {step.step}
                    </span>
                  </div>

                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                    {step.title}
                  </h3>

                  <p className="text-sm text-foreground-600 leading-[1.7] max-w-[260px]">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Rzęd 2: kroki 4–6 */}
          <div className="relative">
            {/* Linia pozioma */}
            <div className="absolute top-[28px] left-[16.66%] right-[16.66%] h-[2px] bg-primary-500/20" />

            <div className="grid grid-cols-3 gap-8">
              {processSteps.slice(3, 6).map((step, index) => (
                <div
                  key={step.step}
                  className="flex flex-col items-center text-center animate-fade-in-up"
                  style={{ animationDelay: `${(index + 4) * 150}ms` }}
                >
                  <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full border-2 border-primary-500 bg-background-50 mb-5">
                    <span className="font-heading text-sm font-bold text-primary-500">
                      {step.step}
                    </span>
                  </div>

                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                    {step.title}
                  </h3>

                  <p className="text-sm text-foreground-600 leading-[1.7] max-w-[260px]">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ============================================================
            MOBILE – Vertical timeline (1 kolumna)
        ============================================================ */}
        <div className="md:hidden relative">
          {/* Linia pionowa */}
          <div className="absolute left-[27px] top-0 bottom-0 w-[2px] bg-primary-500/20" />

          <div className="flex flex-col gap-8">
            {processSteps.map((step, index) => (
              <div
                key={step.step}
                className="relative flex items-start gap-5 animate-fade-in-up"
                style={{ animationDelay: `${(index + 1) * 100}ms` }}
              >
                {/* Kółeczko */}
                <div className="relative z-10 w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-primary-500 bg-background-50">
                  <span className="font-heading text-sm font-bold text-primary-500">
                    {step.step}
                  </span>
                </div>

                {/* Treść */}
                <div className="pt-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-[1.7]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-14 md:mt-18 animate-fade-in-up animation-delay-700">
          <a
            href="tel:698084044"
            className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-primary-500 text-primary-500 font-semibold rounded-full hover:bg-primary-50 hover:scale-105 active:scale-95 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Zadzwoń – omówimy proces
            <i className="ri-phone-line" />
          </a>
        </div>
      </div>
    </section>
  );
}